import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContainerBox from "view/accounts/components/ContainerBox";
import Navigation from "view/accounts/components/Navigation";
import PinInput from "view/accounts/components/PinInput";
import { reduxForm, SubmissionError } from 'redux-form';
import { requestVerification, requestPatchUser } from '../../../modules/user/actions'

function mapStateToProps(state) {
  return {
    email: state.user.email,
    newEmail: state.user.newEmail
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    requestVerification,
    requestPatchUser
  }, dispatch);
}


class ConfirmEmail extends Component {

  componentWillMount() {
    this.setState(state=>({...state, loading: false}));
  }

  submit(results) {
    console.log(JSON.stringify(results, null, 2));
    return new Promise((resolve, reject) => {
      if (!results.pin || results.pin.length < 6) {
        return reject(new SubmissionError({
          'pin': 'Please fill in all numbers.'
        }));
      }

      this.props.requestVerification({
        email: this.props.email, 
        token: results.pin,
        type: 'email',
        callback: (result) => {
          if (!result.err) {
            this.props.history.push('/my-account/profile-updated');
            return resolve();
          } else {
            if (result.err.message === 'PIN Limit Exceeded') {
              this.props.history.push(`/my-account/too-many-pin-attempts`);
            }
            return reject(new SubmissionError({
              pin: result.err.message
            }));
          }
        }
      });
    });
  }

  resendCode() {
    this.setState(state=>({...state, loading: true}));
    let isWaiting = true;
    setTimeout(() => {
      if (!isWaiting) {
        this.setState(state=>({...state, loading: false}));
      } else {
        isWaiting = false;
      }
    }, 1000);
    this.props.requestPatchUser({
      data: {
        email: this.props.newEmail,
      },
      callback: ()=>{
        if (!isWaiting) {
          this.setState(state=>({...state, loading: false}));
        } else {
          isWaiting = false;
        }
      }
    });
  }

  render() {
    return (
      <ContainerBox type="my-account account-confirm-email" title="Confirm email" noLinks isLoading={this.props.submitting || this.state.loading}>
        <p><strong className="blue">{this.props.newEmail}</strong></p>
        <p>A message with a verification code was sent to your email address. Please enter the code below.</p>
        <form onSubmit={this.props.handleSubmit(results => this.submit(results))} autoComplete="off">
          <PinInput name="pin" length={6} resendCode={()=>this.resendCode()} onSubmit={this.props.handleSubmit(results => this.submit(results))}/>
          <Navigation secondaryText="Back" secondaryLink="/my-account/change-email" primaryText="Next" primaryLink="/signup-enter-mobile" />
        </form>

      </ContainerBox>
    )
  }
}

ConfirmEmail = reduxForm({
  form: 'ConfirmEmail' // a unique name for this form
})(ConfirmEmail);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);